<template>
  <div class="promotion_mobile_footer">
    <div class="promotion_mobile_footer_content">
      <div class="promotion_mobile_footer_left">
        <nuxt-link
          :to="`/company/${$store.state.company.companyId}`"
          :target="$_newtab"
        >
          <div class="promotion_mobile_footer_logo">
            <img :src="logo || defaultCompanyLogo" />
          </div>
        </nuxt-link>
        <nuxt-link
          :to="`/company/${$store.state.company.companyId}`"
          :target="$_newtab"
        >
          <div class="promotion_mobile_footer_name">
            <div class="promotion_mobile_footer_title">{{ title }}</div>
            <div v-show="evaluateAvg > 0" class="promotion_mobile_footer_star">
              <span>口碑:</span>
              <no-ssr>
                <star-rating
                  :read-only="true"
                  :show-rating="false"
                  :rating="evaluateAvg"
                  :star-size="8"
                />
              </no-ssr>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="promotion_mobile_footer_right">
        <div
          @click="onClickRegist"
          class="promotion_mobile_footer_button default_button"
        >
          我要报名
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.promotion_mobile_footer {
  background: white;
  width: 100%;

  .promotion_mobile_footer_content {
    height: 76px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .promotion_mobile_footer_left {
      display: flex;
      flex-direction: row;
      align-items: center;
      .promotion_mobile_footer_logo {
        margin: 0px 10px;
        width: 36px;
        height: 36px;
        > img {
          object-fit: cover;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .promotion_mobile_footer_name {
        .promotion_mobile_footer_title {
          font-size: 16px;
          font-weight: 600;
          color: rgba(68, 68, 68, 1);
          line-height: 16px;
        }
        .promotion_mobile_footer_star {
          margin-top: 8px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(68, 68, 68, 1);
          line-height: 12px;
        }
      }
    }
    .promotion_mobile_footer_button {
      width: 148px;
      height: 46px;
      margin-right: 20px;
    }
  }
}
</style>

<script>
export default {
  props: {
    logo: {
      default: 'https://media.1qizhuang.com/bgw/83682454',
      type: String
    },
    title: {
      default: '小满装饰',
      type: String
    },
    evaluateAvg: {
      default: 4,
      type: Number
    }
  },
  methods: {
    onClickRegist() {
      this.$emit('onClickPromotionFooter')
    }
  }
}
</script>
